import { useQuery } from '@apollo/client';

import usageQuery from './usageQuery.graphql';

export type BillingPeriod = {
  count: number;
  limit: number;
  limitTerm: string;
  planId: string;
  planName: string;
  startTime: string;
  endTime: string;
};

export const useApiUsageData = () => {
  const { data = {}, loading, refetch } = useQuery(usageQuery);

  return {
    refetch,
    loading,
    data: data?.apiUsage?.data || [],
    total: data?.apiUsage?.total || 0,
    billingPeriodCounts: data?.apiUsage?.billingPeriodCounts || [],
  };
};
